<template>
  <div class="software" oncontextmenu="return false">
    
      <layer></layer>
      <sdata></sdata>
      <crm></crm>
      <!-- <Four></Four> -->
      <function></function>
      <foot></foot>
      <Isoftware class="phsoft"></Isoftware>
  </div>
</template>

<script>
import Layer from './layer'
import Sdata from './sdata'
import Crm from './crm'
import Function from './function'
import Foot from '../hardProduct/foot'
import Isoftware from './Isoftware'


export default {
  name:'software',
  components:{Layer,Sdata,Crm,Function,Foot,Isoftware},
  mounted(){
    this.$store.state.hardDot = false
    this.$store.state.homeDot = false
    this.$store.state.softDot = true
    this.$store.state.coopDot = false
    this.$store.state.aboutDot = false
    this.$store.state.d4 = '';
  }
}
</script>

<style scoped>
  .software{
    width: 100%;
    height: auto;
  }
  @media screen and (min-width:768px){
   .software .phsoft{
      display: none;
    }
  }
  @media screen and (max-width:768px){
   .software .phsoft{
      display: block;
    }
    .software .contents,.software .bottom-foot{
      display: none;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/software/software.vue